<template>
	<el-footer v-if="temp.show && headerMode == 0" height="initial" id="footer" class="copyright">
		<div class="wrap">
			<div class="footerlogo">
				<img :src="$store.state.app_config.system?$store.state.app_config.system.white_logo:global.oss_website+'/pc/images/footLogo.png'" class="bt_logo">
			</div>
			<template v-if="$store.state.app_config.system">
				<div class="footerinfo" v-html="$store.state.app_config.system.icp"></div>
			</template>
			<template v-else>
				<div class="footerinfo">
					<p data-v-308d3a04="">Copyright © 2025-2026 学业水平综合培训</p>
					<p data-v-308d3a04="">
						对本站有任何建议、意见或投诉联系我们：
						<a data-v-308d3a04="" title="邮箱" href="mailto:kefu@test5184.com" class="email">kefu@test5184.com</a>
					</p>
				</div>
			</template>
		</div>
	</el-footer>
</template>

<script>
export default {
	name: 'footerView'
	,data () {
		return {
			temp: this.temp.footer
		}
	}
	,mounted:function(){
	}
	,methods:{
	}
	,computed:{
		headerMode(){
			return this.$store.state.layout ? this.$store.state.layout : 0
		}
	},
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/footer.vue